import { forwardRef } from "react";

export interface IDocumentViewerProps {
  url: string;
  name: string;
}

export const DocumentViewer = forwardRef(
  ({ url }: IDocumentViewerProps, ref: React.Ref<HTMLIFrameElement>) => (
    <div className="flex flex-col">
      <iframe
        ref={ref}
        src={`${url}#toolbar=1&view=Fit`}
        className="h-full w-full shadow-none"
        title="Document Viewer"
        allowFullScreen
      />
    </div>
  ),
);
